/* eslint-disable max-len */
import { dwmRepository } from 'common/repositories/index';

angular.module('services')
    .factory('dwmValidations', () => {

        const dwmValidations = {

            getValidationRules() {

                const rulesValidation = dwmRepository.getAll('validation') || {};
                return rulesValidation;

            },

            emailValidator(input) {

                const rulesValidation = dwmValidations.getValidationRules();
                const { regex } = rulesValidation.emails.emailAddress.validation.rules[0];
                const { minLength, maxLength } = rulesValidation.emails.emailAddress.validation;

                const validator = new RegExp(regex);
                return validator.test(input) && input.length >= minLength && input.length <= maxLength;

            },

            bankAccountNumberValidator(input) {

                const rulesValidation = dwmValidations.getValidationRules();
                const { regex } = rulesValidation.bankAccounts.accountNumber.validation.rules[0];
                const { minLength, maxLength } = rulesValidation.bankAccounts.accountNumber.validation;

                if (!input && minLength === 0) {

                    return true;

                }

                const validator = new RegExp(regex);
                return validator.test(input) && input.length >= minLength && input.length <= maxLength;

            },

            bankNameValidator(input) {

                const rulesValidation = dwmValidations.getValidationRules();
                const { regex } = rulesValidation.bankAccounts.name.validation.rules[0];
                const { minLength, maxLength } = rulesValidation.bankAccounts.name.validation;

                const validator = new RegExp(regex);
                return validator.test(input) && input.length >= minLength && input.length <= maxLength;

            },

            ibanValidator(input) {

                const rulesValidation = dwmValidations.getValidationRules();
                const { regex } = rulesValidation.bankAccounts.iban.validation.rules[0];
                const { minLength, maxLength } = rulesValidation.bankAccounts.iban.validation;

                const validator = new RegExp(regex);
                return validator.test(input) && input.length >= minLength && input.length <= maxLength;

            },

            creditCardNumberValidator(input) {

                const rulesValidation = dwmValidations.getValidationRules();
                const { regex } = rulesValidation.creditDebitCards.cardNumber.validation.rules[0];
                const { minLength, maxLength } = rulesValidation.creditDebitCards.cardNumber.validation;

                const validator = new RegExp(regex);
                return validator.test(input) && input.length >= minLength && input.length <= maxLength;

            },

            creditCardTypeValidator(input) {

                const rulesValidation = dwmValidations.getValidationRules();
                const { minLength } = rulesValidation.creditDebitCards.cardType;

                return input.length >= minLength;

            },

            addressStreet1Validator(input) {

                if (!input) {

                    return false;

                }

                const rulesValidation = dwmValidations.getValidationRules();
                const { regex } = rulesValidation.addresses.street1.validation.rules[0];
                const { minLength, maxLength } = rulesValidation.addresses.street1.validation;

                const validator = new RegExp(regex);
                return validator.test(input) && input.length >= minLength && input.length <= maxLength;

            },

            addressStreet2Validator(input) {

                if (!input) {

                    return true;

                }

                const rulesValidation = dwmValidations.getValidationRules();
                const { regex } = rulesValidation.addresses.street2.validation.rules[0];
                const { minLength, maxLength } = rulesValidation.addresses.street2.validation;

                const validator = new RegExp(regex);

                if (input.length === 0) {

                    return true;

                }

                return validator.test(input) && input.length >= minLength && input.length <= maxLength;

            },

            cityValidator(input) {

                if (!input) {

                    return false;

                }

                const rulesValidation = dwmValidations.getValidationRules();
                const { regex } = rulesValidation.addresses.city.validation.rules[0];
                const { minLength, maxLength } = rulesValidation.addresses.city.validation;

                const validator = new RegExp(regex);
                return validator.test(input) && input.length >= minLength && input.length <= maxLength;

            },

            postalCodeValidator(input) {

                if (!input) {

                    return false;

                }

                const rulesValidation = dwmValidations.getValidationRules();
                const { regex } = rulesValidation.addresses.postalCode.validation.rules[0];
                const { minLength, maxLength } = rulesValidation.addresses.postalCode.validation;

                const validator = new RegExp(regex);
                return validator.test(input) && input.length >= minLength && input.length <= maxLength;

            },

            stateCodeValidator(input) {

                const rulesValidation = dwmValidations.getValidationRules();
                const { regex } = rulesValidation.addresses.stateCode.validation.rules[0];
                const { minLength, maxLength } = rulesValidation.addresses.stateCode.validation;

                const validator = new RegExp(regex);
                return validator.test(input) && input.length >= minLength && input.length <= maxLength;

            },

            driversLicenseNumberValidator(input) {

                const rulesValidation = dwmValidations.getValidationRules();
                const { regex } = rulesValidation.driversLicense.driversLicenseNumber.validation.rules[0];
                const { minLength, maxLength } = rulesValidation.driversLicense.driversLicenseNumber.validation;

                const validator = new RegExp(regex);
                return validator.test(input) && input.length >= minLength && input.length <= maxLength;

            },

            phoneNumberValidator(input) {

                const rulesValidation = dwmValidations.getValidationRules();
                const { regex } = rulesValidation.phoneNumbers.phoneNumber.validation.rules[0];
                const { minLength, maxLength } = rulesValidation.phoneNumbers.phoneNumber.validation;

                const validator = new RegExp(regex);
                return validator.test(input) && input.length >= minLength && input.length <= maxLength;

            },

            phoneCountryCodeValidator(input) {

                const rulesValidation = dwmValidations.getValidationRules();
                const { regex } = rulesValidation.phoneNumbers.countryCode.validation.rules[0];
                const { minLength, maxLength } = rulesValidation.phoneNumbers.countryCode.validation;

                const validator = new RegExp(regex);
                return validator.test(input) && input.length >= minLength && input.length <= maxLength;

            },

            mothersMaidenNameValidator(input) {

                const rulesValidation = dwmValidations.getValidationRules();
                const { regex } = rulesValidation.mothersMaidenName.name.validation.rules[0];
                const { minLength, maxLength } = rulesValidation.mothersMaidenName.name.validation;

                const validator = new RegExp(regex);
                return validator.test(input) && input.length >= minLength && input.length <= maxLength;

            },

            insuranceNameValidator(input) {

                const rulesValidation = dwmValidations.getValidationRules();
                const { regex } = rulesValidation.insuranceCards.providerName.validation.rules[0];
                const { minLength, maxLength } = rulesValidation.insuranceCards.providerName.validation;

                const validator = new RegExp(regex);
                return validator.test(input) && input.length >= minLength && input.length <= maxLength;

            },

            insuranceNumberValidator(input) {

                const rulesValidation = dwmValidations.getValidationRules();
                const { regex } = rulesValidation.insuranceCards.policyNumber.validation.rules[0];
                const { minLength, maxLength } = rulesValidation.insuranceCards.policyNumber.validation;

                const validator = new RegExp(regex);
                return validator.test(input) && input.length >= minLength && input.length <= maxLength;

            },

            gamerTagValidator(input) {

                if (!input) {

                    return false;

                }

                const rulesValidation = dwmValidations.getValidationRules();
                const { regex } = rulesValidation.gamerTags.tag.validation.rules[0];
                const { minLength, maxLength } = rulesValidation.gamerTags.tag.validation;

                const validator = new RegExp(regex);
                return validator.test(input) && input.length >= minLength && input.length <= maxLength;

            },

        };

        return dwmValidations;

    });



// WEBPACK FOOTER //
// ./scripts/common/services/util/dwm-validations.js